import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection } from "../primitives/Section";
export function Quote({ quote, attribution, role, theme = "ink" }: { quote: string; attribution?: string; role?: string; theme?: Theme }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme}>
      <figure className="mx-auto max-w-3xl text-center">
        <blockquote className={`${t.heading} font-display text-display-sm font-medium`}>“{quote}”</blockquote>
        {attribution ? <figcaption className={`${t.muted} mt-6 text-sm`}>{attribution}{role ? <span> · {role}</span> : null}</figcaption> : null}
      </figure>
    </ContainedSection>
  );
}
